import * as React from "react";
import { Route, Link, Redirect, RouteProps } from "react-router-dom";
import * as routes from "./routes";
import { isAuthenticated, userGroups } from "./auth/auth";
import Login from "./auth/login";
import NoAuth from "./auth/noAuth";

import Dashboard from "./pages/dashboard";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Hidden,
  withStyles,
  createStyles,
  Theme
} from "@material-ui/core";
import store, { GlobalState } from "./store";
import * as headerActions from "./store/header/actions";
import { connect } from "react-redux";
import CaseList from "./pages/cases/list";
import { drawerWidth } from "./drawer";
import Messages from "./pages/messages";
import CaseDetail from "./pages/cases/detail";
import MessageDetail from "./pages/messages";
import Users from "./pages/users";
import Reports from "./pages/reports";
import Categories from "./pages/categories";
import Tags from "./pages/tags";
import MailList from "./pages/mailList";
import {
  ROLE_ADMIN,
  ROLE_ENGAGEMENT_EDITOR,
  ROLE_WRITER,
  ROLE_GUEST
} from "./api/constants";
import SearchBar from "./components/searchBar";
import Notifications from "./pages/notifications";
import Profile from "./pages/profile";
import Tools from "./pages/tools";
import Settings from "./pages/settings";
import AddLink from "./pages/tools/addLink";

const AuthRoute = ({ component: Component, ...rest }) => {
  const hasAuth = isAuthenticated();
  let hasPermission = false;
  if (hasAuth) {
    const group = userGroups();
    if (
      group === rest.group ||
      (rest.group.find && rest.group.find(i => i === group))
    ) {
      hasPermission = true;
    }
  }

  return (
    <Route
      {...rest}
      render={props => {
        if (!hasAuth) {
          return (
            <Redirect
              to={{
                pathname: routes.PATH_LOGIN,
                search:
                  props.location.pathname !== "/"
                    ? "redirect=" + props.location.pathname
                    : ""
              }}
            />
          );
        }
        if (hasPermission) {
          return <Component {...props} />;
        } else {
          return <NoAuth />;
        }
      }}
    />
  );
};
const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 64,
      display: "flex",
      flexDirection: "column",
      bottom: 0,
      backgroundColor: "#FCFCFC",
      [theme.breakpoints.up("md")]: {
        top: 0,
        marginLeft: isAuthenticated() ? 240 : 0
      }
    }
  });
interface Props {
  classes: any;
}
class Routes extends React.Component<Props> {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {isAuthenticated() && <SearchBar />}
        {/* <AuthRoute
        groups={SEGMENT_GROUPS}
        path={routes.PATH_CONFIG_GROUP}
        component={UserConfigGroup}
        exact
      /> */}
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR, ROLE_WRITER, ROLE_GUEST]}
          path={routes.PATH_MAIN}
          component={Dashboard}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR, ROLE_WRITER, ROLE_GUEST]}
          path={routes.PATH_CASES}
          component={CaseList}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR, ROLE_WRITER, ROLE_GUEST]}
          path={routes.PATH_STARRED}
          component={CaseList}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR]}
          path={routes.PATH_MESSAGES}
          component={Messages}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR]}
          path={routes.PATH_MESSAGE_DETAIL}
          component={Messages}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR, ROLE_WRITER, ROLE_GUEST]}
          path={routes.PATH_CASE_DETAIL}
          component={CaseDetail}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN]}
          path={routes.PATH_USERS}
          component={Users}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR]}
          path={routes.PATH_REPORTS}
          component={Reports}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR, ROLE_WRITER, ROLE_GUEST]}
          path={routes.PATH_CATEGORIES}
          component={Categories}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR, ROLE_WRITER, ROLE_GUEST]}
          path={routes.PATH_TAGS}
          component={Tags}
          exact
        />
        <AuthRoute
          group={ROLE_ADMIN}
          path={routes.PATH_MAIL_LIST}
          component={MailList}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR, ROLE_WRITER, ROLE_GUEST]}
          path={routes.PATH_NOTIFICATIONS}
          component={Notifications}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR, ROLE_WRITER, ROLE_GUEST]}
          path={routes.PATH_PROFILE}
          component={Profile}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR, ROLE_WRITER]}
          path={routes.PATH_TOOLS}
          component={Tools}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR, ROLE_WRITER]}
          path={routes.PATH_SETTINGS}
          component={Settings}
          exact
        />
        <AuthRoute
          group={[ROLE_ADMIN, ROLE_ENGAGEMENT_EDITOR, ROLE_WRITER]}
          path={routes.PAGE_ADD_LINK}
          component={AddLink}
          exact
        />

        <Route path={routes.PATH_LOGIN} component={Login} exact />
      </div>
    );
  }
}
export default withStyles(styles)(Routes as any);



// WEBPACK FOOTER //
// ./src/navigator.tsx